import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import { RandomUtils } from '../random-utils';

@Component({
  selector: 'app-switcher',
  templateUrl: './switcher.component.html',
  styleUrls: ['./switcher.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SwitcherComponent),
    multi: true
  }],
})
export class SwitcherComponent implements ControlValueAccessor {

  name = RandomUtils.generateRandomString(15);

  @Input()
  labelKey: string;

  @Input()
  disabled = false;

  value: boolean;

  onChange: (value: boolean) => void = () => {
  };

  onTouch: () => void = () => {
  };

  constructor() {
  }

  writeValue(value: any) {
    this.value = value;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  onCheckboxChange(event: Event): void {
    this.onChange((event.target as HTMLInputElement).checked);
  }

}
